import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useLoginStore = defineStore('login-store',()=>{
    const phoneZone = ref("+86") // 区号
    const phoneNumber = ref("") // 手机号
    const agreementCheckOut = ref(false) //协议是否同意
    const verifyCode = ref('') //验证码

    // 修改区号
    const changePhoneZone = (val) =>{
        phoneZone.value = val;
    }

    // 修改区号
    const changePhoneNum = (val) =>{
        phoneNumber.value = val;
        
    }

    // 修改验证码 
    const changeVerifyCode = (val) =>{
        verifyCode.value = val
    }

    // 勾选协议
    const changeAgreementCheck = (val) =>{
        agreementCheckOut.value = val;
        console.log('store执行:agreementCheckOut',agreementCheckOut.value)
    }

    // 清除所有元素
    const clearStoreData = () =>{
        phoneZone.value = "+86";
        phoneNumber.value = "";
        agreementCheckOut.value = false;
        verifyCode.value = "";
    }
    return{
        phoneZone,
        phoneNumber,
        agreementCheckOut,
        verifyCode,
        changePhoneZone,
        changePhoneNum,
        changeAgreementCheck,
        changeVerifyCode,
        clearStoreData
    }
})